import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  BottomNavigation as MuiBottomNavigation, 
  BottomNavigationAction,
  Paper 
} from '@mui/material';
import {
  QrCodeScanner as ScannerIcon,
  DirectionsCar as VehiclesIcon,
  History as HistoryIcon,
  Build as MaintenanceIcon,
} from '@mui/icons-material';

const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/scanner')) return 0;
    if (path.includes('/vehicles') && !path.match(/\/vehicles\/\d+/)) return 1;
    if (path.includes('/maintenance')) return 2;
    if (path.includes('/activity')) return 3;
    return 0;
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/field-agent/scanner');
        break;
      case 1:
        navigate('/field-agent/vehicles');
        break;
      case 2:
        navigate('/field-agent/maintenance');
        break;
      case 3:
        navigate('/field-agent/activity');
        break;
    }
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000,
        height: 64,
        flexShrink: 0,
      }} 
      elevation={3}
    >
      <MuiBottomNavigation
        value={getActiveTab()}
        onChange={handleChange}
        showLabels
        sx={{ 
          height: '100%',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 12px',
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: { xs: '0.7rem', sm: '0.75rem' },
          }
        }}
      >
        <BottomNavigationAction 
          label="Scanner" 
          icon={<ScannerIcon />}
        />
        <BottomNavigationAction 
          label="Véhicules" 
          icon={<VehiclesIcon />}
        />
        <BottomNavigationAction 
          label="Maintenance" 
          icon={<MaintenanceIcon />}
        />
        <BottomNavigationAction 
          label="Activité" 
          icon={<HistoryIcon />}
        />
      </MuiBottomNavigation>
    </Paper>
  );
};

export default BottomNavigation;

